module.exports = require('./helpers/bundle-url').getBundleURL('kmvYf') + "judy-kuriansky.ae73c089.jpg" + "?" + Date.now();